import React from 'react'

import PropTypes from 'prop-types'

import Card from 'app/match/applicationReportPDF/components/Card'
import InfoList from 'app/match/applicationReportPDF/components/InfoList'
import PDFBullet from 'app/match/applicationReportPDF/components/PDFBullet'
import Persona from 'app/match/applicationReportPDF/components/Persona'
import TitleHorizontalLine from 'app/match/applicationReportPDF/components/TitleHorizontalLine'

const propTypes = {
  data: PropTypes.array.isRequired,
  isQLDForm: PropTypes.bool,
  showEmploymentGrossAnnualIncome: PropTypes.bool,
}

const EmploymentDetails = ({
  data = [],
  isQLDForm,
  showEmploymentGrossAnnualIncome = true,
}) => {
  const isEmploymentPrintWithoutGrossAnnualIncome =
    !isQLDForm && !showEmploymentGrossAnnualIncome

  return (
    <div className="employment-details no-break-section">
      <Card
        type={'icon'}
        icon={'icon-new-construction'}
        title={'Employment Details'}
        addClass={'bottom-border mt-0'}
      />
      <div className="custom-row flex-wrap-wrap justify-content-space-between print__display_block">
        {data.length === 0 && <p>No information is provided</p>}
        {data.map((item, index) => {
          const {
            type,
            tenure,
            address,
            addressObj,
            gross_income,
            net_income,
            position,
            employer_abn,
            employer_trading_name,
            show_reason_affecting_employment_line = false,
            reason_affecting_employment,
            employer_name,
            weekly_gross,
          } = item.generalInfo
          const verifyStatusText =
            item.contact.verifyStatus.toLowerCase() === 'pending'
              ? item.contact.verifyStatus
              : `${item.contact.verifyStatus} by`
          const verifyStatusDate =
            item.contact.verifyDate.length && item.contact.verifyDate

          const dataForInfoList = isEmploymentPrintWithoutGrossAnnualIncome
            ? {
                current_or_most_recent_employer: employer_name,
                address,
                net_weekly_income: net_income,
                ...(item.generalInfo.most_recent_employment_end_date && {
                  most_recent_employment_end_date:
                    item.generalInfo.most_recent_employment_end_date,
                }),
              }
            : {
                ...(!isQLDForm && { type }),
                tenure,
                ...(!isQLDForm && { address }),
                ...(showEmploymentGrossAnnualIncome ? { gross_income } : {}),
                ...(!isQLDForm &&
                  (showEmploymentGrossAnnualIncome
                    ? { net_income }
                    : { net_weekly_income: net_income })),
                ...(isQLDForm && { weekly_gross }),
              }
          const companyDetail = {
            employer_abn,
            employer_trading_name,
            type,
            employer_name,
            address: addressObj,
          }
          return (
            <div
              className={`width50p employment-pdf-row-container mb20 no-break-section print__display_inline_block`}
              key={index}
            >
              {!isEmploymentPrintWithoutGrossAnnualIncome && (
                <h2>{position}</h2>
              )}
              <InfoList
                data={dataForInfoList}
                marked={
                  showEmploymentGrossAnnualIncome
                    ? 'gross_income'
                    : 'net_weekly_income'
                }
                companyDetail={companyDetail}
              />

              {!isQLDForm && !isEmploymentPrintWithoutGrossAnnualIncome && (
                <>
                  <TitleHorizontalLine title={'Contact'} />
                  <Persona info={item.contact} />
                  <PDFBullet
                    label={verifyStatusText}
                    value={item.contact.name}
                    supportingText={verifyStatusDate}
                  />
                </>
              )}
              {show_reason_affecting_employment_line &&
                !isQLDForm &&
                !isEmploymentPrintWithoutGrossAnnualIncome && (
                  <div className="mt10">
                    <TitleHorizontalLine title="Reason Affecting Employment" />
                    <div>{reason_affecting_employment}</div>
                  </div>
                )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

EmploymentDetails.propTypes = propTypes

export default EmploymentDetails
